import React from "react";
import PropTypes from "prop-types";

const PresenceSummary = ({ presence }) => {
  if (!presence) {
    return null;
  }

  const { isAvailable, onlineCount } = presence;
  const normalizedCount = Number.isFinite(Number(onlineCount)) ? Number(onlineCount) : 0;

  if (!isAvailable) {
    return (
      <div className="channel-header__presence channel-header__presence--unavailable" role="status">
        <span className="channel-header__presence-note">Presence unavailable</span>
      </div>
    );
  }

  return (
    <div className="channel-header__presence" aria-live="polite" aria-atomic="true">
      <span className="channel-header__presence-count">
        <strong>{normalizedCount}</strong> online
      </span>
    </div>
  );
};

PresenceSummary.propTypes = {
  presence: PropTypes.shape({
    isAvailable: PropTypes.bool,
    onlineCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

PresenceSummary.defaultProps = {
  presence: undefined,
};

export default PresenceSummary;

